import React from 'react';
import Base, { InfiniteScrollListProps } from './Base';

/**
 * PC 版无限滚动列表：空状态图片 100x100，文字 14px。
 */

import styles from './index.module.scss';

const InfiniteScrollListPC: React.FC<InfiniteScrollListProps> = (props) => {
    return (
        <Base
            {...props}
            className={styles.pcList}
        />
    );
};

export default InfiniteScrollListPC;
